<script lang="ts">
  import { link } from "svelte-routing"
  import { Button, Card, Col, Container, Row, Spinner } from "sveltestrap"
  import InfiniteScroll from "svelte-infinite-scroll";
  import RoundTable from "../components/RoundTable.svelte"
  import MetaNFTTable from "../components/MetaNFTTable.svelte"
  import PositionSummary from "../components/PositionSummary.svelte"
  import { query } from "@urql/svelte"
  import {
    getRounds,
    getMetaNfts,
    getTotalRoundValue,
    getTotalMetaNftValue,
    getPairList,
    getRoundList,
    getMetaNFTList,
  } from "../stores/query"
  import { connected, selectedAccount } from "svelte-web3"
  import {
    currentChainId,
    pairListCurrentOffset, pairListIsEndReached,
    pairListSelectedCategories,
    pairListSelectedOrder, pairs,
  } from "../stores/store"
  import { convertMetaNft, convertPairData, convertRound } from "../utils/utils"
  import { ORDER_BY } from "../stores/constants"

  let roundList = [];
  let metaNFTList = [];

  let currentTab = 'all'
  let isRoundEndReached = false;
  let isMetaNFTEndReached = false;

  let isRoundLoading = false;
  let isMetaNFTLoading = false;

  let currentOffset = 0;

  $: paginationStep = $connected && currentTab === 'all' ? 5 : 10;

  const convertAndConcatFetchedRoundList = (page, reset) => {
    reset = reset === true;
    const convertPromises = page.map((elem) => {
      return convertRound($currentChainId, elem);
    })
    Promise.allSettled(convertPromises).then(res => {
      isRoundLoading = false;
      if (reset) {
        roundList = res.filter(e => e.status === 'fulfilled').map(e => e.value);
      } else {
        roundList = roundList.concat(res.filter(e => e.status === 'fulfilled').map(e => e.value));
      }
    })
  }

  const convertAndConcatFetchedMetaNFTList = (page, reset) => {
    reset = reset === true;
    const convertPromises = page.map((elem) => {
      return convertMetaNft($currentChainId, elem);
    })
    Promise.allSettled(convertPromises).then(res => {
      isMetaNFTLoading = false;
      if (reset) {
        metaNFTList = (res.filter(e => e.status === 'fulfilled').map(e => e.value));
      } else {
        metaNFTList = metaNFTList.concat(res.filter(e => e.status === 'fulfilled').map(e => e.value));
      }
    })
  }

  const fetchRoundList = (reset) => {
    if (reset === true) {
      isRoundEndReached = false;
      currentOffset = 0;
    }
    const data = {
      address: $selectedAccount,
      limit: paginationStep,
      offset: currentOffset,
    };

    if (isRoundEndReached || isRoundLoading || !$connected) {
      return;
    }
    isRoundLoading = true;
    getRoundList($currentChainId, data).then(res => {
      const data = res.user.roundTokenBalances;
      if (data.length === 0) {
        isRoundEndReached = true;
      }
      convertAndConcatFetchedRoundList(data, reset);
      currentOffset += paginationStep
    }).catch(e => {console.error(e); isRoundLoading= false;});
  }

  const fetchMetaNFTList = (reset) => {
    if (reset === true) {
      isMetaNFTEndReached = false;
      currentOffset = 0;
    }
    const data = {
      address: $selectedAccount,
      limit: paginationStep,
      offset: currentOffset,
    };
    if (isMetaNFTEndReached || isMetaNFTLoading || !$connected) {
      return;
    }
    isMetaNFTLoading = true;
    getMetaNFTList($currentChainId, data).then(res => {
      const data = res.user.pairs;
      if (data.length === 0) {
        isMetaNFTEndReached = true;
      }
      convertAndConcatFetchedMetaNFTList(data, reset);
      currentOffset += paginationStep;
    }).catch(e => {console.log(e); isMetaNFTLoading = false;});
  }
  //
  // const setRounds = (page) => {
  //   convertRounds($currentChainId, page)
  //     .then(res => rounds.set($rounds.concat(res)));
  // }
  //
  // const setMetaNfts = (page) => {
  //   convertMetaNfts($currentChainId, page)
  //     .then(res => metaNfts.set($metaNfts.concat(res)));
  // }

  $: if ($connected) {
    isMetaNFTEndReached = false;
    isMetaNFTLoading = false;
    isRoundEndReached = false;
    isRoundLoading = false;
    currentOffset = 0;
    if (currentTab === 'all') {
      roundList = [];
      metaNFTList = [];
      fetchRoundList(true);
      fetchMetaNFTList(true);
    } else if (currentTab == 'metanft') {
      metaNFTList = [];
      fetchMetaNFTList(true);
    } else {
      roundList = [];
      fetchRoundList(true);
    }
  }
  //
  // $: try {
  //   if ($connected && !$getRounds.fetching && $getRounds.data !== undefined && $getRounds.data.user !== null) {
  //     const page = $getRounds.data.user.roundTokenBalances;
  //     if (page === null || page.length === 0) {
  //       loadDone = true;
  //     } else {
  //       setRounds(page);
  //     }
  //   }
  // } catch(e) {
  //   console.error(e);
  // }
  //
  // $: try {
  //   if ($connected && !$getMetaNfts.fetching && $getRounds.data !== undefined && $getMetaNfts.data.user !== null) {
  //     const page = $getMetaNfts.data.user.pairs
  //     if (page === null || page.length === 0) {
  //       loadDone = true;
  //     } else {
  //       setMetaNfts(page);
  //     }
  //   }
  // } catch(e) {
  //   console.error(e);
  // }

  $: {
    if ($connected) {
      getTotalRoundValue.variables.address = $selectedAccount;
      query(getTotalRoundValue);
      getTotalMetaNftValue.variables.address = $selectedAccount;
      query(getTotalMetaNftValue);
    }
  }

</script>

<Row>
  <div class="page-header"></div>
  <div class="page-subheader"></div>
</Row>
<Container>
  <Row>
    <Col class="page-title pf-header">
      My portfolio
    </Col>
  </Row>
  <Row>
    <Col class="col-auto pf-tab pf-tab-activate">
      <a href="#">
        Positions
      </a>
    </Col>
    <Col class="col-auto pf-tab">
      <a href="/portfolio/bids" use:link>
        My bid offers
      </a>
    </Col>
  </Row>
  <Row class="pf-ctg align-items-center gx-3">
    <Col class="col-auto">
      <Button
        class={'button-line pf-ctg-btn' + (currentTab === 'all' ? ' pf-ctg-btn-activate' : '')}
        on:click={() => currentTab = 'all'}
      >
        All
      </Button>
    </Col>
    <Col class="col-auto">
      <Button
        class={'button-line pf-ctg-btn' + (currentTab === 'round' ? ' pf-ctg-btn-activate' : '')}
        on:click={() => currentTab = 'round'}
      >
        Round
      </Button>
    </Col>
    <Col class="col-auto">
      <Button
        class={'button-line pf-ctg-btn' + (currentTab === 'metanft' ? ' pf-ctg-btn-activate' : '')}
        on:click={() => currentTab = 'metanft'}
      >
        MetaNFT
      </Button>
    </Col>
  </Row>
  <Row>
    <Col class="pf-subtitle">
      {#if currentTab === 'all'}
        All Summary
      {:else if currentTab === 'round'}
        Round Summary
      {:else}
        MetaNFT Summary
      {/if}
    </Col>
  </Row>
  <Row>
    <Col>
      <PositionSummary tab={currentTab}/>
    </Col>
  </Row>
  <Row>
    <Col class="pf-subtitle">
      All Positions
    </Col>
  </Row>
  {#if currentTab === 'all'}
    <Row>
      <Col class="pf-table-label">
        Round
      </Col>
    </Row>
    <Row>
      <Col class="pf-sample-table">
        <RoundTable data={roundList}/>
      </Col>
    </Row>
    <Row>
      <Col class="text-center">
        <Button class="button-line pf-table-button" on:click={() => currentTab = 'round'}>
          See more
          <img class="icon-small" src="/icons/arrow-right.svg" alt="placeholder"/>
        </Button>
      </Col>
    </Row>
    <Row>
      <Col class="pf-table-label">
        MetaNFT
      </Col>
    </Row>
    <Row>
      <Col class="pf-sample-table">
        <MetaNFTTable data={metaNFTList} />
      </Col>
    </Row>
    <Row class="text-center">
      <Col>
        <Button class="button-line pf-table-button" on:click={() => currentTab = 'metanft'}>
          See more
          <img class="icon-small" src="/icons/arrow-right.svg" alt="placeholder"/>
        </Button>
      </Col>
    </Row>
  {:else if currentTab === 'round'}
    <Row>
      <Col class="pf-table">
        <RoundTable  data={roundList}/>
      </Col>
    </Row>
    <Row class="text-center">
      {#if (isMetaNFTLoading || isRoundLoading) }
        <div class="spinner-div"><Spinner light size="lg" /></div>
      {/if}
    </Row>
    <Row>
      <Col class="text-center">
        <a href="#top">
          <Button class="button-line pf-table-button">
            <img class="icon-small" src="/icons/arrow-top.svg" alt="placeholder"/>
            To the top
          </Button>
        </a>
      </Col>
    </Row>
    <InfiniteScroll threshold={5} on:loadMore={fetchRoundList} window={true} />
  {:else}
    <Row>
      <Col class="pf-table">
        <MetaNFTTable data={metaNFTList}/>
      </Col>
    </Row>
    <Row class="text-center">
      {#if (isMetaNFTLoading || isRoundLoading) }
        <div class="spinner-div"><Spinner light size="lg" /></div>
      {/if}
    </Row>
    <Row class="text-center">
      <Col>
        <a href="#top">
          <Button class="button-line pf-table-button">
            <img class="icon-small" src="/icons/arrow-top.svg" alt="placeholder"/>
            To the top
          </Button>
        </a>
      </Col>
    </Row>
    <InfiniteScroll threshold={5} on:loadMore={fetchMetaNFTList} window={true} />
  {/if}

</Container>

<style>
    .spinner-div {
        margin-bottom: 40px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>

